<div
	class="au-dialog-container right-sidebar-content nice-scroll visible-scroll colored-scroll-track"
>
	<div class="file-name">{{ currentFile.name }}</div>
	<mat-icon matRipple (click)="close()" class="close-icon">close</mat-icon>

	<au-file-viewer [fileData]="currentFile"></au-file-viewer>

	<div
		matRipple
		matRippleColor="rgba(107, 102, 208, 0.2)"
		[matRippleDisabled]="currentIndex === 0"
		class="navigation-arrow arrow-left"
		(click)="scrollLeft()"
		[ngClass]="{ 'arrow-disabled': currentIndex === 0 }"
		[class.arrow-disabled]="currentIndex === 0"
	>
		<mat-icon color="accent">keyboard_arrow_left</mat-icon>
	</div>
	<div
		matRipple
		matRippleColor="rgba(107, 102, 208, 0.2)"
		[matRippleDisabled]="currentIndex === this.filesList.length - 1"
		class="navigation-arrow arrow-right"
		(click)="scrollRight()"
		[class.arrow-disabled]="currentIndex === filesList.length - 1"
	>
		<mat-icon color="accent">keyboard_arrow_right</mat-icon>
	</div>
</div>
